module.exports = __webpack_public_path__ + "Gauge4_Yellow-0061ef74d138c85c1ee5f30947079c9b.png";